export default <T>(timeout: number, result: T): Promise<T> =>
    new Promise((resolve) => {
        setTimeout(() => resolve(result), timeout);
    });
